/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router';

import { InputGroup, Form, FormGroup, FormControl, ControlLabel, Label, Button, Panel, Glyphicon, ListGroup, ListGroupItem, Grid, Row, Col, Image, Thumbnail, Well} from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import ProductEditView from './ProductEditView.react';
import UserStore from '../../stores/UserStore';
import APIActions from '../../actions/apiActions';
import ProductStore from '../../stores/ProductStore';

class ProductsView extends React.Component {
    constructor(props) {
        console.log("[ProductsView] - initialisation");

        super(props);
        this.state = {
            products : null,
            errorMsg : null,
            expandedStates : [],
            filterText : "",
            editingProductUuid : null,
            selectedProduct : null
        };
        this.onPanelClicked = this.onPanelClicked.bind(this);
        this._onProductChange = this._onProductChange.bind(this);
    }

    componentDidMount() {
        console.log("[ProductsView] - componentDidMount");
        ProductStore.addChangeListener(this._onProductChange) ;
        this.reloadProducts();
    }

    componentWillUnmount() {
        console.log("[ProductsView] - componentWillUnmount");
        ProductStore.removeChangeListener(this._onProductChange);
    }

    _onProductChange() {
        let products = ProductStore.products() ;
        let expandeds = [];
        for (let i = 0; i < products.length; ++i) {
            expandeds[i] = false;
        }
        this.setState({products: products, errorMsg: null, expandedStates: expandeds});
    }

    reloadProducts() {
        console.log("Reloading Products");
        APIActions.getAllProducts() ;
    }

    productEditFinished(changesSaved) {
        console.log("Product Edit Finished: ", changesSaved);
        this.setState({editingProductUuid: null, selectedProduct : null});
        if (changesSaved) {
            this.reloadProducts();
        }
    }

    handleFilterChange(newFilterText) {
        this.setState({filterText: newFilterText});
        this.setAllExpandedStates(false);
    }

    onPanelClicked(productIndex) {
        let expandeds = this.state.expandedStates;
        expandeds[productIndex] = !expandeds[productIndex];
        this.setState({expandedStates: expandeds});
    }
    setAllExpandedStates(newState) {
        let expandeds = this.state.expandedStates;
        for (let i = 0; i < expandeds.length; ++i) {
            expandeds[i] = newState;
        }
        this.setState({expandedStates: expandeds});
    }
    editProduct(uuid) {
        this.setState({editingProductUuid: uuid});
    }
    newProduct() {
        this.setState({editingProductUuid: "new", selectedProduct: {}});
    }
    getTopForm() {
        let isAdmin = UserStore.isAdministrator() ;

        return (
          <div>
           <Grid>
                <Row>
                    <Well className="productHeader">
                        <h1>Product Management</h1>
                    </Well>
                </Row>
                <Row>
                    <Form inline>
                        <FormGroup controlId="formInlineName">
                        <ControlLabel>Search Products</ControlLabel>
                        {' '}
                        <InputGroup>
                            <FormControl type="text" onChange={(e)=>this.handleFilterChange(e.target.value)} value={this.state.filterText} placeholder="" />
                            <InputGroup.Button onClick={()=>this.handleFilterChange("")}>
                                <Button><Glyphicon glyph="search" /></Button>
                            </InputGroup.Button>
                        </InputGroup>
                        </FormGroup>
                        {' '}
                        <Button bsStyle="success" onClick={() => this.newProduct()}><Glyphicon glyph="plus" />{' '}Add Product</Button>{' '}
                        <Button bsStyle="success" onClick={() => this.reloadProducts()}><Glyphicon glyph="refresh" />{' '}Refresh Products</Button>
                    </Form>
                </Row>
                <Row>&nbsp;</Row>
            </Grid>

          </div>
        );
    }

    actionEdit(p) {
        // let s = this.state ;
        // s.selectedProduct = p ;
        // s.editingProductUuid = p.productId;
        // this.setState(s);
        this.props.history.push("/products/product?id=" + p.productId);
    }

    render() {
        let self = this ;

        if (this.state.products) {
            let productViews = [];
            let filterLower = this.state.filterText.toLowerCase();
            for (let i = 0; i < this.state.products.length; ++i) {  // "let" is required for correctly capturing the value of i
                let product = this.state.products[i];
                if (!this.state.filterText || product.name.toLowerCase().includes(filterLower)) {
                    productViews.push(
                        <Col xs={6} md={4}  key={product.productId}>
                            <Thumbnail src={product.imageUrl} alt="50x50" onClick={self.actionEdit.bind(self,product)}>
                                <h3>{product.name}</h3>
                                <p>{product.desc}</p>
                                {(product.hidden || false) && <p><b>No public visibility</b></p>}
                            </Thumbnail>
                        </Col>
                    );
                }
            }
            return (
              <div>
                {this.getTopForm()}
                <Grid>
                    <Row>
                        {productViews}
                    </Row>
                </Grid>
              </div>);
        }
        else {
            return (<ReactSpinner/>);
        }
    }
}

export default withRouter(ProductsView);



// WEBPACK FOOTER //
// ./src/app/components/products/productsView.react.js